import React from "react";
import { Trash2, Download } from "lucide-react";
import { formatDate, downloadCsv } from "./adminUtils";

export default function MessagesPanel({ items, onDelete }) {
  function exportCsv() {
    downloadCsv("contact-messages.csv", items, [
      "name",
      "email",
      "phone",
      "message",
      "created_at",
    ]);
  }

  return (
    <>
      <div className="flex items-center justify-between mb-3">
        <h2 className="font-display text-2xl text-[#7d8e54]">Contact Messages</h2>
        <button
          onClick={exportCsv}
          disabled={items.length === 0}
          className="flex items-center gap-2 text-sm border border-[#d6dcb6] px-3 py-1.5 hover:bg-[#f6f8ec] disabled:opacity-40"
        >
          <Download className="w-4 h-4" /> Export CSV
        </button>
      </div>
      {items.length === 0 ? (
        <p className="text-sm text-[#7d8e54] italic">No messages yet.</p>
      ) : (
        <div className="space-y-3">
          {items.map((m) => (
            <div key={m.id} className="border border-[#d6dcb6] bg-white">
              <div className="flex items-start justify-between bg-[#f6f8ec] px-4 py-2 border-b border-[#d6dcb6]">
                <div>
                  <p className="font-semibold text-[#5b6a37]">{m.name}</p>
                  <p className="text-xs text-[#7d8e54]">
                    {m.email}
                    {m.phone ? ` \u2022 ${m.phone}` : ""} \u2022 {formatDate(m.created_at)}
                  </p>
                </div>
                <button
                  onClick={() => onDelete(m.id)}
                  className="text-red-700 hover:text-red-900 p-1"
                  title="Delete"
                  aria-label="Delete message"
                >
                  <Trash2 className="w-4 h-4" />
                </button>
              </div>
              <div className="p-4 whitespace-pre-wrap text-sm leading-relaxed">{m.message}</div>
            </div>
          ))}
        </div>
      )}
    </>
  );
}
